import { useMemo, type FC } from 'react'
import classnames from 'classnames'
import { observer } from 'mobx-react-lite'
import { Avatar, Badge, IconButton, layoutStore, Typography } from 'shared/ui'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { type IQuickFilterCard } from 'pages/conversations/ui/ConversationMenu/store/types'
import { useConversationMenuContext } from 'pages/conversations/ui/ConversationMenu/context'
import styles from './styles.module.scss'

type IMenuQuickFilterCardProps = {
  item: IQuickFilterCard
}

export const MenuQuickFilterCard: FC<IMenuQuickFilterCardProps> = observer(({ item }) => {
  const store = useConversationMenuContext()
  const entities = useEntitiesContext()
  const { loadingUpdateTeam, pageLayoutStore, quickFiltersMenuStore, isActiveConversationSearch } =
    store
  const { handleQuickFilter, disabledButton } = quickFiltersMenuStore

  const avatarInfo = useMemo(() => {
    return entities.usersStore.user?.avatarInfo
  }, [item.id])

  const handleClickUpdateTeam = async () => {
    if (layoutStore.isMediumView) {
      pageLayoutStore.handleChangeCollapse(true)
    }

    if (loadingUpdateTeam || (item.active && !isActiveConversationSearch)) return

    handleQuickFilter(item.id)
  }

  if (item.id === 'draft' && item.count === 0) return null

  return (
    <div
      className={classnames(styles.wrap, {
        [styles.active]: item.active,
        [styles.disabled]: disabledButton,
      })}
      onClick={handleClickUpdateTeam}
    >
      <div
        className={classnames(styles.boxName, {
          [styles.unread]: item.count,
        })}
      >
        <div className={styles.icon}>
          {item.id === 'assigned' && avatarInfo ? (
            <Avatar size={16} info={avatarInfo} className={styles.avatar} />
          ) : (
            <IconButton
              icon={item.iconL}
              size={'small'}
              color={'transparent'}
              fontSize={16}
              ariaLabel='MenuCardInbox'
              iconProps={{ color: item.active ? 'var(--content-brand-primary)' : undefined }}
            />
          )}
        </div>

        <Typography
          variant={Boolean(item.count) ? 'body-md-semibold' : 'body-md-regular'}
          ellipsis
          color={'var(--content-primary-primary)'}
          ariaLabel={'name'}
        >
          {item.label}
        </Typography>
      </div>

      {Boolean(item.count) && (
        <div className={styles.right}>
          <div
            className={classnames(styles.boxInfo, {
              [styles.unread]: item.count,
            })}
          >
            <div className={styles.infoItem}>
              <Badge content={item.count} ariaLabel={'MenuQuickFilterCard_unreadMessagesCount'} />
            </div>
          </div>
        </div>
      )}
    </div>
  )
})
